import VitalsignsBoxInfo from "./VitalsignsBoxInfo";

export default VitalsignsBoxInfo;